import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import PageDetail from './pages/PageDetail';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

function App() {
  return (
    <Layout>
      <Routes>
        {/* Front Page */}
        <Route path="/" element={<Home />} />

        {/* Skovservice Pages */}
        <Route path="/skovservice" element={<PageDetail />} />
        <Route path="/skovservice/:slug" element={<PageDetail />} />

        {/* Vognmandskørsel & Transport Pages */}
        <Route path="/vognmand" element={<PageDetail />} />
        <Route path="/walking-floor-trailer" element={<PageDetail />} />
        <Route path="/blokvognstransport" element={<PageDetail />} />

        {/* Naturpleje Pages */}
        <Route path="/naturpleje" element={<PageDetail />} />
        <Route path="/naturpleje/:slug" element={<PageDetail />} />

        {/* Stub- & Rodfræsning Page */}
        <Route path="/stub-og-rodfraesning" element={<PageDetail />} />

        {/* Om os Page */}
        <Route path="/om-os" element={<PageDetail />} />

        {/* Gallery Page */}
        <Route path="/galleri" element={<GalleryPage />} />

        {/* Contact Page */}
        <Route path="/kontakt" element={<ContactPage />} />

        {/* Error Pages */}
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="/403" element={<ForbiddenPage />} />

        {/* Fallback 404 Route */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
}

export default App;
